import React from 'react';
import type { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import useHashParam from 'use-hash-param';

// While every other instance of useAuth comes from ./useAuth,
// this one needs to comes from @reckon-web/auth-store.
// This is because the ./useAuth contains hoosk that need to access
// different context that won't be ready here.
import { useAuth } from '@reckon-web/auth-store';

import { isSecureRoute } from '../Navigation';
export type UrlFragmentManagerProps = PropsWithChildren<{}>;

export const UrlFragmentManager = ({ children }: UrlFragmentManagerProps) => {
  const router = useRouter();
  const [accessToken, setAccessToken] = useHashParam('accessToken', '');

  const { credentials, setCredentials, isLoading, setIsLoading } = useAuth();

  React.useEffect(() => {
    if (!isSecureRoute(router.pathname)) {
      setIsLoading(false);
      return;
    }

    if (!!isLoading && !!accessToken && accessToken !== 'null') {
      setCredentials({ accessToken });
      setAccessToken('');
      setIsLoading(false);
      return;
    }

    if (isLoading) {
      setIsLoading(false);
    }
  }, [
    accessToken,
    credentials?.accessToken,
    isLoading,
    router.pathname,
    setAccessToken,
    setCredentials,
    setIsLoading,
  ]);

  return <>{children}</>;
};
